import { Injectable, inject } from '@angular/core';
import { AssetService, ModalService } from '@schenck/rotec-components';
import { switchMap } from 'rxjs/operators';
import { MachineTaskInfo } from 'src/api';
import { TaskModalService } from 'src/components';
import { MachineTaskService } from 'src/services';

@Injectable()
export class MachineHistoryModalService extends TaskModalService<MachineTaskInfo> {
  private readonly assetService = inject(AssetService);

  public machine$ = this.task$.pipe(
    switchMap((task) => this.assetService.machine$(task.machineId))
  );

  public plant$ = this.machine$.pipe(
    switchMap((machine) => this.assetService.plant$(machine.plantId))
  );

  constructor() {
    const taskService = inject(MachineTaskService);
    const modalService = inject(ModalService);

    super(taskService, modalService, null);
  }
}
